import ls from 'local-storage';
import {
  PACKAGES_LOCAL_STORAGE_CACHE_KEY,
  COMMON_LOCAL_STORAGE_CACHE_KEY,
} from '../constants/localStorageConstants';
import loadPackagesCacheThunk from './loadPackagesCacheThunk';
import loadCommonCacheThunk from './loadCommonCacheThunk';
import {
  getIsValidCache,
} from '../utils/cacheUtils';
import { COMMON_CACHE_VERSION, PACKAGES_CACHE_VERSION } from '../constants/cacheConstants';

const loadCacheThunk = () => (dispatch, getState) => {
  const packagesCache = ls.get(PACKAGES_LOCAL_STORAGE_CACHE_KEY);
  const commonCache = ls.get(COMMON_LOCAL_STORAGE_CACHE_KEY);

  const state = getState();
  const isFlightHotelCacheSupported = getIsValidCache(packagesCache, PACKAGES_CACHE_VERSION, state);
  const isCommonCacheSupported = getIsValidCache(commonCache, COMMON_CACHE_VERSION, state);

  if (isFlightHotelCacheSupported && isCommonCacheSupported) {
    const packagesCacheTimestamp = packagesCache?.timestamp || 0;
    const commonCacheTimestamp = commonCache?.timestamp || 0;
    if (packagesCacheTimestamp >= commonCacheTimestamp) {
      dispatch(loadPackagesCacheThunk());
    } else {
      dispatch(loadCommonCacheThunk());
    }
  } else if (isFlightHotelCacheSupported) {
    dispatch(loadPackagesCacheThunk());
  } else if (isCommonCacheSupported) {
    dispatch(loadCommonCacheThunk());
  }
};

export default loadCacheThunk;
